<template>
  <div class="object-list-wrapper">
    <div class="list-cont table">
      <div class="list-header heading centered">

        <div class="flex align-center justify-left object-links">
          <router-link :to="{ name: 'purchases' }" class="link" :class="{selected: objectSet === 'purchases'}">
            Purchases
          </router-link>
          <router-link :to="{ name: 'businesses' }" class="link" :class="{selected: objectSet === 'businesses'}">
            Businesses
          </router-link>
          <router-link :to="{ name: 'categories' }" class="link" :class="{selected: objectSet === 'categories'}">
            Categories
          </router-link>
        </div>
      </div>

      <component :is="objectView" class="body" />
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue'

import ListCard from '@/components/lists/ListCard'
import BusinessItem from '@/components/lists/BusinessItem'
import BusinessList from '@/components/lists/BusinessList'
import CategoryItem from '@/components/lists/CategoryItem'
import CategoryList from '@/components/lists/CategoryList'
import PurchaseItem from '@/components/lists/PurchaseItem'
import PurchaseList from '@/components/lists/PurchaseList'

export default {
  name: 'ObjectList',

  setup() {
    return {
    }
  },

  data() {
    return {
      detailKeys: [
        'desc',
        {
          key: 'details',
          isLink: true,
        },
      ],
      objectSet: '',
      objectView: '',
    };
  },

  computed: {

  },

  methods: {
  },

  created() {
    this.objectSet = this.$route.name
    switch (this.objectSet) {
      case 'purchases':
        this.objectView = markRaw(PurchaseList)
        break
      case 'purchase':
        this.objectView = markRaw(PurchaseItem)
        break
      case 'businesses':
        this.objectView = markRaw(BusinessList)
        break
      case 'business':
        this.objectView = markRaw(BusinessItem)
        break
      case 'categories':
        this.objectView = markRaw(CategoryList)
        break
      case 'category':
        this.objectView = markRaw(CategoryItem)
        break
      default:
        this.objectView = markRaw(PurchaseList)
        break
    }
  },

  components: {
    ListCard,
    BusinessList,
    CategoryList,
    PurchaseList,
  },
};
</script>

<style lang="scss">
.object-list-wrapper {
  height: 100%;
  overflow: auto;

  .object-links {

    .link {
      color: color(primary);
      font-weight: $bold;
      text-decoration: none;
      padding: $padding;
      text-align: center;
      border-bottom: 2px solid transparent;

      &:hover, &.selected {
        border-color: color(primary);
      }
    }
  }


}
</style>
